import { useState } from "react";
import Spinner from "../../Spinner";
import Error from "../../alerts/Error";

const initialUser = {
    email: '',
    firstName: '',
    lastName: ''
};

function AddUser({ getUsers }) {
    const [user, setUser] = useState(initialUser);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    async function createUser(user) {
        setLoading(true);
        const response = await fetch(process.env.REACT_APP_endPoint + '/users', {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(user)
        });
        const jsonResponse = await response.json();
        if (response.status === 200) {
            getUsers();
        }
        else {
            setError(jsonResponse.error);
        }
        setLoading(false);
    }

    async function onSubmit(evt) {
        evt.preventDefault();
        setError(null);

        await createUser(user);
    }

    function onChange(evt) {
        switch (evt.target.type) {
            case "checkbox":
                setUser({
                    ...user,
                    [evt.target.id]: evt.target.checked
                });
                break;
            case "number":
                const number = parseFloat(evt.target.value);
                setUser({
                    ...user,
                    [evt.target.id]: number
                });
                break
            default:
                console.log(evt.target.value);
                console.log(user);
                setUser({
                    ...user,
                    [evt.target.id]: evt.target.value
                });
        }
    }

    return (
        <div>
            <button className={"btn btn-success mb-3"} data-bs-toggle={"modal"} data-bs-target={"#addUserModal"}>Add user</button>
            <div className={"modal fade"} id={"addUserModal"} tabIndex="-1" aria-labelledby="addUserModalLabel" aria-hidden="true">
                <div className={"modal-dialog modal-lg"}>
                    <div className={"modal-content"}>
                        <form onSubmit={onSubmit}>
                            <div className={"modal-header"}>
                                <h5 className={"modal-title"} id={"addUserModalLabel"}>Add user</h5>
                                <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"} />
                            </div>
                            <div className={"modal-body"}>
                                {error && <Error message={error} /> }
                                <div className="row mb-3">
                                    <div className={"col"}>
                                        <label htmlFor="firstName" className={"form-label"}>First Name:</label>
                                        <input type="text" id={"firstName"} value={user.firstName} className={"form-control"} placeholder={""} required={true} onChange={onChange}/>
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className={"col"}>
                                        <label htmlFor="lastName" className={"form-label"}>Last Name:</label>
                                        <input type="text" id={"lastName"} className={"form-control"} value={user.lastName} placeholder={""} required={true} onChange={onChange}/>
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className={"col"}>
                                        <label htmlFor="email" className={"form-label"}>Email:</label>
                                        <input type="text" id={"email"} className={"form-control"} value={user.email} placeholder={""} required={true} onChange={onChange}/>
                                    </div>
                                </div>

                                {/*<div className="row mb-3">
                                    <div className={"col"}>
                                        <label htmlFor="rights" className={"form-label"}>Rights:</label>
                                        <select id="rights" className={"form-select"} multiple={true} onChange={(evt) => {
                                            const selectedOptions = Array.from(evt.target.selectedOptions).map(option => option.value);
                                            setUser(prev => { return {...prev, rights: selectedOptions }});
                                        }}>
                                            <option key={"admin"} value={"admin"}>Admin</option>
                                            <option key={"manager"} value={"manager"}>Manager</option>
                                            <option key={"accountant"} value={"accountant"}>Accountant</option>
                                            <option key={"pm"} value={"pm"}>PM</option>
                                        </select>

                                    </div>
                                </div>*/}
                            </div>
                            <div className={"modal-footer justify-content-between"}>
                                <button type={"button"} className={"btn btn-secondary"} data-bs-dismiss={"modal"}>Close</button>
                                <button type={"submit"} className={"btn btn-success"} disabled={loading}>{loading ? <Spinner />: 'Add user'}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddUser;
